import CryptoJS from "crypto-js";

export const formatCurrency = (number,currency =  'Php') => {
    return new Intl.NumberFormat('en-PH', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
    }).format(number);
};

export const encryptSHA256 = (input) => {
  return CryptoJS.SHA256(input).toString();
};
